import { useReduxState } from 'hooks';
import { Badge, Link, MoreOptions, TimeIndicator } from 'components/common';
import { BoxTableCell, BoxTableRow } from 'components/common/box';
import { SiteSettingsThemesDelete } from '.';

interface Props {
  as: string;
  color: string;
  href: string;
  id: number;
  themeEnabledStatus: 'Default' | 'Conditional' | 'Disabled';
  title: string;
  updatedAt: string;
  updateThemes: () => void;
}

const SiteSettingsThemesLink = ({
  as,
  color,
  href,
  id,
  themeEnabledStatus,
  title,
  updatedAt,
  updateThemes
}: Props) => {
  const { language, theme } = useReduxState();

  return (
    <BoxTableRow>
      <BoxTableCell>
        <div>
          <div className="color" />
          <Link
            as={as}
            href={href}
            linkColor={theme.textColorLight}
            text={title}
          />

          <style jsx>{`
            .color {
              background-color: ${color};
              border-radius: 3px;
              display: inline-block;
              margin-right: 10px;
              position: relative;
              top: 2px;
              height: 15px;
              width: 15px;
            }
          `}</style>
        </div>
      </BoxTableCell>
      <BoxTableCell>
        <TimeIndicator language={language} timeString={updatedAt} />
      </BoxTableCell>
      <BoxTableCell>
        <Badge
          category={
            themeEnabledStatus === 'Default'
              ? 'success-light'
              : themeEnabledStatus === 'Conditional'
              ? 'warning-light'
              : 'default'
          }
          key={title}
          text={themeEnabledStatus}
        />
      </BoxTableCell>
      <BoxTableCell shrink={true}>
        <MoreOptions>
          <SiteSettingsThemesDelete themeId={id} updateThemes={updateThemes} />
        </MoreOptions>
      </BoxTableCell>
    </BoxTableRow>
  );
};

export default SiteSettingsThemesLink;
